export default __webpack_public_path__ + "static/media/pallasziporyn.7dc406db.jpg";